import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/codeclan.webp';
import screenshot_target from '../../../images/letterfunnel/roberttinga.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Robert Tinga"
      firstname="Robert"
      companyname="Codeclan"
      competition="Working Talent en Polteq"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/roberttinga.js